import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { AdminCustomersStateData } from "@/types/customer"

export type AdminCustomersState = {
  data: AdminCustomersStateData
  error: string | null
}

export const adminCustomersInitialState: AdminCustomersState = {
  data: {
    customers: [],
    pagination: {
      pageNumber: 1,
      pageSize: 10,
      totalElements: 0,
      totalPages: 0,
    },
  },
  error: null,
}

const slice = createSlice({
  name: "adminCustomers",
  initialState: adminCustomersInitialState,
  reducers: {
    setAdminCustomersAction(state, { payload }: PayloadAction<AdminCustomersStateData>) {
      state.data = payload
      state.error = null
    },
    setAdminCustomersErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload
    },
  },
})

export const { setAdminCustomersAction, setAdminCustomersErrorAction } = slice.actions
export default slice.reducer
